export default __webpack_public_path__ + "static/media/avenir-roman.4133a710.woff";